import { configureStore } from "@reduxjs/toolkit";
import UserMaintanence from "../Redux/UserMaintanence";
import CoursesUpload from "../Redux/CoursesUpload";
export default configureStore({
    reducer: {
      userRoles: UserMaintanence,
      coursesData: CoursesUpload
    }})